export default {
    statistics: 'Статистика',

    statistic_option: {
        OFFER: 'Статистика услуг',
        REVENUE: 'Статистика доходов',
        CUSTOM_RESERVATION_PRICE: 'Статистика использования напоминаний',
        CUSTOM_RESERVATION_SEND: 'Статистика отправленных напоминаний',
    },

    total: {
        offer: 'Общее количество бронирований: ',
        revenue: 'Общий доход: ',
    },
    reminder: {
        label: 'Напоминание',
        placeholder: 'Выберите напоминание',
    },
}
